import {
  FDStack,
} from '@facet-wealth/design';
import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  Timeline,
} from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Timeline';
import ProposalCFPInsight from 'Organisms/ProposalCFPInsight';
import { TermSectionListItemLayout } from './TermSectionListItemLayout';
import metaOverrideSet from './metaOverrideSet';

export const RoadmapExecutiveSummaryOverview = ({ shouldAutoOpenCFPMessage }) => {
  const { resource } = useMetaLayoutContext();

  const termSections = resource.attr('termSections')?.resources().list();
  if (!termSections) {
    return null;
  }

  return (
    <FDStack direction={'column'} spacing={4} {...dataAttrs('roadmap-executive-summary-overview-section')}>
      <MetaControlField attr={'title'} />
      <Timeline
        style={{
          flex: 0,
        }}
      >
        {termSections?.map((termSectionRes, i) => (
          <MetaResourceRenderer
            key={termSectionRes.id()}
            layout={TermSectionListItemLayout}
            resource={termSectionRes}
            LayoutProps={{
              isLastSection: i === (termSections.length - 1),
            }}
            metaOverrideSet={metaOverrideSet}
          />
        ))}
      </Timeline>
      <ProposalCFPInsight
        insightResource={resource}
        shouldAutoDisplayDialog={shouldAutoOpenCFPMessage}
      />
    </FDStack>
  );
};
